import { useState } from 'react'
import { Mesh } from 'three'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { GlassOrPolyMaterial } from '../../window/side/glass/GlassOrPolyMaterial'

interface Props {
  positionX: number
  poles: number
}

export const RoofGlass = ({ positionX }: Props): JSX.Element => {
  const {
    polesTopNumber,
    userAngle,
    userWidth,
    roofLogWidth,
    verandaTyp,
    isQubus,
    schwelleSize,
  } = useMeasures()
  const { opacity, roughness, roofCoverings, roofGlassDepth, glasColor } =
    useRoof()
  const roofWidth =
    (userWidth - (isQubus ? verandaTyp.log.width : 0)) / (polesTopNumber - 1)
  const position = roofWidth! * positionX - verandaTyp.roofBar.depth / 2

  const length = roofLogWidth + schwelleSize.depth + (isQubus ? 0 : 0),
    width = verandaTyp.roofBar.width,
    deg = userAngle,
    rad = (deg * Math.PI) / 180,
    offset = Math.min(Math.tan(rad) * width, length / 2)

  const [ref, setRef] = useState<Mesh>()

  return (
    <group
      position={[
        (userWidth! -
          (isQubus ? verandaTyp.log.width : 0) -
          verandaTyp.roofBar.depth -
          roofWidth!) /
          2 -
          position,
        verandaTyp.roofBar.width + roofGlassDepth / 2,
        -offset,
      ]}
    >
      <mesh
        // @ts-ignore
        ref={setRef}
        rotation={[0, 0, 0]}
        position={[0, 0, length / 2]}
        castShadow={false}
      >
        <boxGeometry
          args={[
            roofWidth - verandaTyp.roofBar.depth / 2,
            roofGlassDepth,
            length,
          ]}
        />

        <GlassOrPolyMaterial
          parent={ref}
          isGlass={roofCoverings.glas}
          opacity={opacity}
          roughness={roughness}
          color={glasColor}
        />
      </mesh>
    </group>
  )
}
